// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "PicturesSection-module--wrapper--+3cSo";
export var buttonWrapper = "PicturesSection-module--buttonWrapper--6F7jg";